<template>
  <multiselect
    v-model="modelValue"
    label="text"
    track-by="value"
    :placeholder="placeholder"
    :close-on-select="true"
    :disabled="readonly"
    :showLabels="false"
    :multiple="false"
    :options="options"
  />
</template>
    
<script>
export default {
  name: "SingleSelect",
  props: {
    value: String,
    valueProperty: String,
    options: {
      type: Array,
      required: true,
    },
    trackBy: {
      type: String,
      default: "value",
    },
    placeholder: {
      type: String,
      default: "",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {};
  },
  // mounted() {
  //     this.value = this.vModel;
  // },
  computed: {
    modelValue: {
      get: function () {
        if (this.valueProperty) {
          for (let v of this.options) {
            if (v[this.valueProperty] == this.value) {
              return v;
            }
          }
          return null;
        } else {
          return this.value;
        }
      },
      set: function (value) {
        if (!value) {
          this.$emit("update:value", null);
        } else {
          if (this.valueProperty) {
            this.$emit("update:value", value[this.valueProperty]);
          } else {
            this.$emit("update:value", value);
          }
        }
      },
    },
  },
  //   watch: {
  //     value: function (newValue) {
  //       this.$emit("update:title", newTitle);
  //       this.vModel = newValue;
  //     },
  //   },
};
</script>

<style>
.multiselect__tags {
  padding: 0px !important;
}

.multiselect__tags span {
  padding: 10px 10px 2px 5px !important;
}
</style>